import { usePrivateAuthoringPartner } from 'bundles/enterprise-admin-custom-courses/components/PrivateAuthoringPartnerProvider';
import { noPrivateAuthoringCanUseCustomCourses } from 'bundles/enterprise-admin-custom-courses/utils/helpers';
import { getPrivateAuthoringPartnerIdForCourseBuilder } from 'bundles/enterprise-admin-custom-courses/utils/privateAuthoringUtils';
import { useEnterpriseAdminPermissions } from 'bundles/enterprise-admin-roles/components/EnterprisePermissionsProvider';
import { useEnterpriseAdminContext } from 'bundles/enterprise-admin/EnterpriseAdminContext';

/**
 * Computes whether the current admin can use the course builder.
 * Replicates the inline computation from AdminHeaderAndNav class component.
 */
export const useCanUseCourseBuilder = (): boolean => {
  const { enterpriseAuthoringPartners } = usePrivateAuthoringPartner();
  const { contracts } = useEnterpriseAdminContext();
  const { getIsOrganizationDomainAdmin } = useEnterpriseAdminPermissions();

  return (
    noPrivateAuthoringCanUseCustomCourses(getIsOrganizationDomainAdmin(), contracts) ||
    !!getPrivateAuthoringPartnerIdForCourseBuilder(enterpriseAuthoringPartners)
  );
};
